import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CorePopover, CorePopoverOverlayWindow } from "@svs/angular";
import { FeedbackChipsComponent } from "../feedback-chips/feedback-chips.component";

@Component({
  selector: "app-feedback-popover",
  imports: [
    FeedbackChipsComponent,
    CorePopoverOverlayWindow,
  ],
  templateUrl: "./feedback-popover.component.html",
  styleUrl: "./feedback-popover.component.scss",
})
export class FeedbackPopoverComponent {
  @Input() popover: CorePopover;
  @Output() feedbackSubmitted = new EventEmitter<string[]>();
  @Output() dismissed = new EventEmitter<void>();

  selected: string[] = [];
}
